import Configuration from "../Service/configuration.js";
import DataService from "../Service/data-service.js";
var dataService = new DataService();
var config = new Configuration()

export async function performLogout(userID, userEmail, token, logout, router) {
    const payload = {
        userID: userID,
        email: userEmail,
        token: token,
    };

    const response = await dataService.callWithPostWithoutToken(
        config.SERVICE_NAME_LOGOUT,
        payload
    );
    if (response.success === true) {
        logout();
        router.push("/");
    }
}